module.exports = __webpack_public_path__ + "static/media/planet-ringed.5098ce0b.svg";